import { render, staticRenderFns } from "./OCheckBox.vue?vue&type=template&id=15dc7848&scoped=true"
import script from "./OCheckBox.vue?vue&type=script&lang=js"
export * from "./OCheckBox.vue?vue&type=script&lang=js"
import style0 from "./OCheckBox.vue?vue&type=style&index=0&id=15dc7848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc7848",
  null
  
)

export default component.exports